// src/services/addressService.js
import { authSecureApi } from '../utils/apiConfig';

export const addressService = {
  getAll: async () => {
    try {
      const response = await authSecureApi.get('/api/v1/user/address');
      return response.data;
    } catch (error) {
      console.error("Error fetching addresses:", error);
      throw error;
    }
  },

  add: async (data) => {
    try {
      const response = await authSecureApi.post('/api/v1/user/address', data);
      return response.data;
    } catch (error) {
      console.error("Error adding address:", error);
      throw error;
    }
  },

  update: async (addressId, data) => {
    try {
      const response = await authSecureApi.put(`/api/v1/user/address/${addressId}`, data);
      return response.data;
    } catch (error) {
      console.error("Error updating address:", error);
      throw error;
    }
  },

  delete: async (addressId) => {
    try {
      const response = await authSecureApi.delete(`/api/v1/user/address/${addressId}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting address:", error);
      throw error;
    }
  },

  getByPincode: async (pincode) => {
    try {
      const response = await authSecureApi.get(`/api/v1/user/address/pincode/${pincode}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching pincode details:", error);
      throw error;
    }
  }
};